var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/prop-types */
import React, { createRef, forwardRef, useEffect, useRef, useCallback } from 'react';
import Cleave from 'cleave.js';
import cn from 'classnames';
import styles from 'core-components/src/components/maskfield/maskfield.scss';
const MaskField = forwardRef((_a, ref) => {
    var { maskType, maskPattern, blocks, prefix, uppercase, delimiter, delimiters, thousandGroupStyle, numericOnly, onCardTypeChange, raised, loading, invalid, small, big, fluid, icon, iconAtRight, className, onChange, value } = _a, props = __rest(_a, ["maskType", "maskPattern", "blocks", "prefix", "uppercase", "delimiter", "delimiters", "thousandGroupStyle", "numericOnly", "onCardTypeChange", "raised", "loading", "invalid", "small", "big", "fluid", "icon", "iconAtRight", "className", "onChange", "value"]);
    const inputRef = createRef();
    const inputRefBak = useRef(null);
    const cleaveRef = useRef();
    const onCardProviderChange = useCallback((brand) => {
        let maxLength = 20;
        let delimitersLength = 3;
        const nativeInput = inputRefBak.current;
        // VISA AND MASTERCARD CONTAINS 16 DIGITS
        if (['visa', 'mastercard'].includes(brand)) {
            maxLength = 16;
        }
        if (brand === 'diners') {
            maxLength = 14;
            delimitersLength = 2;
        }
        if (brand === 'amex') {
            maxLength = 15;
            delimitersLength = 2;
        }
        nativeInput.maxLength = maxLength + delimitersLength;
        nativeInput.dataset.cardType = brand;
        onCardTypeChange(brand);
    }, [inputRef.current]);
    useEffect(() => {
        if (ref && !ref.current) {
            // eslint-disable-next-line no-param-reassign
            ref.current = inputRef.current;
        }
        inputRefBak.current = inputRef.current;
        inputRef.current.addEventListener('input', onChange);
        if (!cleaveRef.current) {
            const options = {
                delimiter,
                numericOnly,
                uppercase,
                prefix
            };
            if (maskType) {
                options[maskType] = true;
            }
            if (delimiters.length) {
                options.delimiters = delimiters;
            }
            if (blocks.length) {
                options.blocks = blocks;
            }
            if (maskType === 'creditCard') {
                options.onCreditCardTypeChanged = onCardProviderChange;
                options.delimiter = '-';
            }
            if (maskType === 'numeral') {
                options.numeralThousandsGroupStyle = thousandGroupStyle;
            }
            if (maskType === 'date') {
                options.datePattern = maskPattern;
            }
            if (maskType === 'time') {
                options.timePattern = maskPattern;
            }
            if (maskType === 'phone') {
                options.phoneRegionCode = 'PE';
            }
            cleaveRef.current = new Cleave(inputRef.current, options);
        }
    }, [inputRef.current]);
    useEffect(() => {
        inputRef.current.value = value;
    }, [value]);
    const coreStyles = cn({
        [styles.maskfield]: true,
        [styles.raised]: raised,
        [styles.invalid]: invalid,
        [styles.small]: small,
        [styles.big]: big,
        [styles.fluid]: fluid,
        [styles.iconAtRight]: iconAtRight,
        [styles.loading]: loading,
        [className]: className
    });
    return (React.createElement("div", { className: coreStyles },
        icon ? React.cloneElement(icon, { 'data-icon': '' }) : null,
        React.createElement("input", Object.assign({ ref: inputRef }, props)),
        React.createElement("div", { className: styles.loadingAnimation },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
});
MaskField.defaultProps = {
    maskType: null,
    maskPattern: [],
    blocks: [],
    prefix: '',
    uppercase: false,
    delimiter: '',
    delimiters: [],
    thousandGroupStyle: 'thousand',
    numericOnly: false,
    onCardTypeChange: () => {
        /* IMPLEMENTED BY USER */
    }
};
export { MaskField };
